// extracted by mini-css-extract-plugin
module.exports = {"crumb":"BreadCrumb_crumb__xCrFk","crumbActive":"BreadCrumb_crumbActive__cUp3E"};